<script>
export const group = 'Full'
</script>

<script setup>
import DarioScheduledProgramsMedia from '../default/DarioScheduledProgramsMedia.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import { ref, nextTick } from 'vue'

defineProps({
  item: Object,
})

const transition = ref(null)

const startTransition = async () => {
  await nextTick()
  if (transition.value) {
    transition.value.start()
  }
}
</script>

<template>
  <ToFullBottomRight ref="transition" :manualStart="true">
    <DarioScheduledProgramsMedia class="bg-q-cr-red-darker" :item="item" @loaded="startTransition" />
  </ToFullBottomRight>
</template>
